






























































































import Component from "vue-class-component";
import { BaseRootPageComponent } from "@/components/BaseRootPageComponent";

import CoreAPI from "@/utils/core-api";
import * as modals from "@/utils/modals";
import DeleteLocationModal from "./DeleteLocationModal.vue";
import LoadingIndicator from "@/components/LoadingIndicator.vue";

@Component({
  components: {
    DeleteLocationModal,
    LoadingIndicator
  }
})
export default class Locations extends BaseRootPageComponent {
  loading = true;
  search = "";
  newLocationModalActive = false;
  editLocationModalActive = false;
  deleteLocationModalActive = false;
  locations: any[] = [];
  location: any = {};

  get displayedItems() {
    if (!this.locations) {
      return [];
    }

    // FYI sort null/undefined last since that's what localeCompare(undefined) does
    return this.locations.filter(c => c.ip.indexOf(this.search) !== -1).sort((a, b) => a.ip?.localeCompare(b.ip) ?? 1);
  }

  async created() {
    this.setTitle("Locations");
    await this.fetchLocations();
  }

  async fetchLocations() {
    try {
      this.loading = true;
      this.locations = await CoreAPI.getLocations();
    } catch (error) {
      this.locations = [];

      if ((error as any).isNetworkError) {
        await modals.showLostConnectionModal(this.$bvModal);
      } else {
        await modals.showUnexpectedErrorModal(this.$bvModal);
      }
    } finally {
      this.loading = false;
    }
  }

  showDeleteLocationModal(l: any) {
    this.location = Object.assign({}, l);
    this.deleteLocationModalActive = true;
  }

  hideDeleteLocationModal(success: boolean) {
    this.deleteLocationModalActive = false;
    if (success) {
      this.fetchLocations();
    }
  }
}
